import StUfService from "@/services/StUfService";

export const stUf = {
  namespaced: true,
  state: {
    stUf: {},
  },
  actions: {
    getStUf({ commit }, payload) {
      return StUfService.GetStUf(payload).then(
        (stUf) => {
          return Promise.resolve(stUf);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postStUf({ commit }, payload) {
      return StUfService.PostStUf(payload).then(
        (stUf) => {
          return Promise.resolve(stUf);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putStUf({ commit }, payload) {
      return StUfService.PutStUf(payload).then(
        (stUf) => {
          return Promise.resolve(stUf);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteStUf({ commit }, payload) {
      return StUfService.DeleteStUf(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getStUfOData({ commit }, payload) {
      return StUfService.GetStUfOData(payload).then(
        (stUf) => {
          return Promise.resolve(stUf);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default stUf;
